import { takeEvery, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { SettingActions } from '../actions';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { RouteUrls } from '../configs/routeUrls';

const agreementHistoriesUrl= '/api/setting/agreement-histories';
const agreementUrl = '/api/setting/agreements';
const attachmentConfigUrl= '/api/setting/attachment-configs';
const authorizationSettingsUrl = '/api/setting/authorization-settings';
const commentConfigUrl= '/api/setting/comment-configs';
const passwordConfigUrl= '/api/setting/password-configs';
const thematicAreaUrl = '/api/setting/thematic-areas';
const templateUrl = '/api/setting/templates';

export function* watchGetThematicArea() {
	yield takeEvery(SettingActions.GetThematicAreaAction.Request, getThematicArea);
}
function* getThematicArea(action) {
	try {
		let thematicArea = yield call(getThematicAreaRequest, action.payload);

		yield put({
			type: SettingActions.GetThematicAreaAction.Success,
			payload: thematicArea
		});
	} catch (err) {
		yield put({
			type: SettingActions.GetThematicAreaAction.Failure
		});
		toastr.error(
			'Błąd pobierania kategorii',
			'Wystąpił niespodziewany błąd podczas pobierania kategorii'
		);
	}
}
function getThematicAreaRequest(id) {
	return axios
		.get(`${thematicAreaUrl}/${id}`)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}

export function* watchLoadThematicAreas() {
	yield takeEvery(SettingActions.LoadThematicAreasAction.Request, loadThematicAreas);
}
function* loadThematicAreas() {
	try {
		const response = yield call(loadThematicAreasRequest);

		yield put({
			type: SettingActions.LoadThematicAreasAction.Success,
			payload: response
		});
	} catch (e) {
		yield put({ type: SettingActions.LoadThematicAreasAction.Failure });
		toastr.error(
			'Błąd pobierania kategorii',
			'Wystąpił niespodziewany błąd podczas pobierania listy kategorii'
		);
	}
}
function loadThematicAreasRequest() {
	return axios
		.get(`${thematicAreaUrl}`)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}
export function* watchUnloadThematicArea() {
	yield takeEvery(SettingActions.UnloadThematicAreaAction.Request, unloadThematicArea);
}

function* unloadThematicArea() {
	yield put({
		type: SettingActions.UnloadThematicAreaAction.Success
	});
}

export function* watchGetPasswordConfigs() {
	yield takeEvery(SettingActions.GetPasswordConfigsAction.Request, getPasswordConfigs);
}

function* getPasswordConfigs() {
	try {
		let passwordConfigs = yield call(getPasswordConfigsRequest);

		yield put({
			type: SettingActions.GetPasswordConfigsAction.Success,
			payload: passwordConfigs
		});
	} catch (ex) {
		yield put({
			type: SettingActions.GetPasswordConfigsAction.Failure
		});
	}
}

function getPasswordConfigsRequest() {
	return axios
		.get(`${passwordConfigUrl}`)
		.then((response) => response.data)
		.catch((err) => {
		throw err;
	});
}

export function* watchFetchTemplates() {
	yield takeEvery(SettingActions.FetchTemplatesAction.Request, fetchTemplates);
}

function* fetchTemplates() {
	try {
		let templates = yield call(fetchTemplatesRequest);

		yield put({
			type: SettingActions.FetchTemplatesAction.Success,
			payload: templates
		});
	} catch (err) {
		yield put({
			type: SettingActions.FetchTemplatesAction.Failure
		});
	}
}

function fetchTemplatesRequest() {
	return axios
		.get(templateUrl)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}

export function* watchGetTemplate() {
	yield takeEvery(SettingActions.GetTemplateAction.Request, getTemplate);
}

function* getTemplate(action) {
	try {
		let template = yield call(getTemplateRequest, action.payload);

		yield put({
			type: SettingActions.GetTemplateAction.Success,
			payload: template
		});
	} catch (err) {
		yield put({
			type: SettingActions.GetTemplateAction.Failure
		});
	}
}

function getTemplateRequest(id) {
	return axios
		.get(`/api/setting/templates/${id}`)
		.then((response) => response.data)
		.catch((err) => {
		throw err;
	});
}

export function* watchGetAttachmentConfigs() {
	yield takeEvery(SettingActions.GetAttachmentConfigsAction.Request, getAttachmentConfigs);
}

function* getAttachmentConfigs() {
	try {
		let atachmentConfigs = yield call(getAttachmentConfigsRequest);

		yield put({
			type: SettingActions.GetAttachmentConfigsAction.Success,
			payload: atachmentConfigs
		});
	} catch (ex) {
		yield put({
			type: SettingActions.GetAttachmentConfigsAction.Failure
		});
	}
}

function getAttachmentConfigsRequest() {
	return axios
		.get(`${attachmentConfigUrl}`)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
	});
}

export function* watchLoadAgreementHistories() {
    yield takeEvery(SettingActions.LoadAgreementHistoriesAction.Request, loadAgreementHistories);
}
function* loadAgreementHistories() {
    try {
        const response = yield call(loadAgreementHistoriesRequest);

        yield put({
            type: SettingActions.LoadAgreementHistoriesAction.Success,
            payload: response
        });
    } catch (e) {
        yield put({type: SettingActions.LoadAgreementHistoriesAction.Failure});
        toastr.error('Błąd pobierania zgód i regulaminów',
            'Wystąpił niespodziewany błąd podczas pobierania listy zgód i regulaminów');

    }
}
function loadAgreementHistoriesRequest() {
    return axios.get(`${agreementHistoriesUrl}`)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
};

export function* watchGetAgreement() {
    yield takeEvery(SettingActions.GetAgreementAction.Request, getAgreement);
}

function* getAgreement(action) {
    try {
        let agreement = yield call(getAgreementRequest, action.payload);

        yield put({
            type: SettingActions.GetAgreementAction.Success,
            payload: agreement
        })
    } catch (err) {
        yield put({
            type: SettingActions.GetAgreementAction.Failure,
        });
        toastr.error('Błąd pobierania regulaminu',
            'Wystąpił niespodziewany błąd podczas pobierania regulaminu');
    }
}
function getAgreementRequest(id) {
	return axios
		.get(`${agreementUrl}/${id}`)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
};
export function* watchUnloadAgreement() {
	yield takeEvery(SettingActions.UnloadAgreementAction.Request, unloadAgreement);
}

function* unloadAgreement() {
	yield put({
		type: SettingActions.UnloadAgreementAction.Success
	});
}

export function* watchGetAuthorizationServiceSettings() {
	yield takeEvery(SettingActions.GetAuthorizationServiceSettingsAction.Request, getAuthorizationServiceSettings);
}

function* getAuthorizationServiceSettings() {
	try {
		let authorizationSettings = yield call(getAuthorizationServiceSettingsRequest);

		yield put({
			type: SettingActions.GetAuthorizationServiceSettingsAction.Success,
			payload: authorizationSettings
		});
	} catch (err) {
		yield put({
			type: SettingActions.GetAuthorizationServiceSettingsAction.Failure
		});
	}
}

function getAuthorizationServiceSettingsRequest() {
    return axios.get(`${authorizationSettingsUrl}`)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}

export function* watchGetCommentConfigs() {
	yield takeEvery(SettingActions.GetCommentConfigsAction.Request, getCommentConfigs);
}

function* getCommentConfigs() {
	try {
		let commentSettings = yield call(getCommentConfigsRequest);

		yield put({
			type: SettingActions.GetCommentConfigsAction.Success,
			payload: commentSettings
		});
	} catch (err) {
		yield put({
			type: SettingActions.GetCommentConfigsAction.Failure
		});
	}
}

function getCommentConfigsRequest() {
    return axios.get(`${commentConfigUrl}`)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}